import React, { useState } from "react";
import CurvesChangeAnalysisBox from "./CurvesChangeAnalysisBox";
import BalanceAnalysisBox from "./BalanceAnalysisBox";
import clsx from "clsx";
import inbody_female_img from "@Images/inbody-female.png";

const PART_TYPE_CURVES_CHANGE = "curvesChange";
const PART_TYPE_BALANCE = "balance";

const CurveAndBalancePartAnalysisSection = ({ className, sourceData, compareData }) => {
	const [selectedPartType, setSelectedPartType] = useState(PART_TYPE_CURVES_CHANGE);

	const handlePartTypeSwitch = type => {
		setSelectedPartType(type);
	};

	const parseEquilibriumEval = val => {
		switch (String(val)) {
			case "0":
				return "平衡";
			case "1":
				return "輕度失衡";
			case "2":
				return "嚴重失衡";
			default:
				return null;
		}
	};

	const { deltaNeckMC, deltaChestMC, deltaAbdomenMC, deltaHipMC, deltaRightArmMC, deltaLeftArmMC, deltaRightThighMC, deltaLeftThighMC } = compareData || {};

	const curvesChangeData = {
		neck: { name: "頸圍", value: sourceData?.neckMC, deltaValue: deltaNeckMC },
		chest: { name: "胸圍", value: sourceData?.chestMC, deltaValue: deltaChestMC },
		waist: { name: "腰圍", value: sourceData?.abdomenMC, deltaValue: deltaAbdomenMC },
		hip: { name: "臀圍", value: sourceData?.hipMC, deltaValue: deltaHipMC },
		armLeft: { name: "左臂", value: sourceData?.leftArmMC, deltaValue: deltaLeftArmMC },
		armRight: { name: "右臂", value: sourceData?.rightArmMC, deltaValue: deltaRightArmMC },
		legLeft: { name: "左大腿", value: sourceData?.leftThighMC, deltaValue: deltaLeftThighMC },
		legRight: { name: "右大腿", value: sourceData?.rightThighMC, deltaValue: deltaRightThighMC },
	};

	const upperBodyStatus = parseEquilibriumEval(sourceData?.ubbEval);
	const lowerBodyStatus = parseEquilibriumEval(sourceData?.lbbEval);
	const trunkStatus = parseEquilibriumEval(sourceData?.ulbbEval);
    const balancedImageName = compareData?.balancedImageName ?? "";

	const balanceData = {
		upperBody: { name: "上半身", status: upperBodyStatus },
		lowerBody: { name: "下半身", status: lowerBodyStatus },
		trunk: { name: "上下半身", status: trunkStatus },
		balancedImageName: balancedImageName,
	};

	return (
		<div className={clsx("part-analysis-section", className)}>
			<div className={"part-analysis-section__controller"}>
				<button className={clsx({ active: selectedPartType === PART_TYPE_CURVES_CHANGE })} onClick={() => handlePartTypeSwitch(PART_TYPE_CURVES_CHANGE)}>
					曲線變化
				</button>
				<button className={clsx({ active: selectedPartType === PART_TYPE_BALANCE })} onClick={() => handlePartTypeSwitch(PART_TYPE_BALANCE)}>
					身體平衡
				</button>
			</div>
			<div className="part-analysis-section__body">
				<img className="part-analysis-section__base-img" src={inbody_female_img} alt="inbody" />
				{selectedPartType === PART_TYPE_CURVES_CHANGE ? <CurvesChangeAnalysisBox data={curvesChangeData} /> : <BalanceAnalysisBox data={balanceData} />}
			</div>
		</div>
	);
};
export default CurveAndBalancePartAnalysisSection;
